<template>
    <header class="fth">
        <span class="fth-icon" aria-hidden="true">
            <i :class="icon"></i>
        </span>
        <div class="fth-body">
            <h3 class="fth-title">{{ title }}</h3>
            <p v-if="subtitle" class="fth-subtitle">{{ subtitle }}</p>
        </div>
        <div v-if="$slots.actions" class="fth-actions">
            <slot name="actions" />
        </div>
    </header>
</template>

<script>
export default {
    name: 'FormTabHeader',
    props: {
        icon: { type: String, default: 'fal fa-info-circle' },
        title: { type: String, required: true },
        subtitle: { type: String, default: '' }
    }
}
</script>

<style scoped>
.fth {
    display: flex;
    align-items: center;
    gap: var(--v2-space-3);
    padding: var(--v2-space-4) var(--v2-space-5);
    border-bottom: 1px solid var(--v2-border-subtle);
    background: var(--v2-surface-0);
}

.fth-icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--v2-radius-md);
    background: var(--v2-primary-soft);
    color: var(--v2-primary);
    font-size: 1.1rem;
}

.fth-icon i {
    color: inherit !important;
}

.fth-body {
    flex: 1;
    min-width: 0;
}

.fth-title {
    margin: 0;
    font-size: 1.1rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.01em;
    line-height: 1.3;
}

.fth-subtitle {
    margin: 3px 0 0;
    font-size: var(--v2-text-xs-size);
    color: var(--v2-text-3);
    line-height: 1.4;
}

.fth-actions {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: var(--v2-space-2);
}

@media (max-width: 900px) {
    .fth {
        flex-wrap: wrap;
    }

    .fth-actions {
        width: 100%;
        justify-content: flex-start;
    }
}
</style>
